<template>
    <nav v-if="breadcrumbs.length" class="flex text-gray-700" aria-label="Breadcrumb">
        <ol class="flex flex-wrap">
            <!-- В мобильной версии показываем только предыдущую страницу -->
            <li v-if="!showAllBreadcrumbs" class="mb-3">
                <div @click.prevent="showAllBreadcrumbs = true"
                     class="bg-baseColor rounded h-[18px] w-[40px] flex items-center justify-center gap-1 me-2">
                    <div v-for="i in 3" :key="i" class="h-[5px] w-[5px] rounded-full bg-gray-500"></div>
                </div>
            </li>
            <template v-if="showAllBreadcrumbs">
                <li v-for="(breadcrumb, key) in breadcrumbs" :key="key" class="mb-3">
                    <div class="flex items-center">
                        <IconAngleLeft v-if="key !== 0" class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <Link v-if="key !== breadcrumbs.length - 1" :href="breadcrumb.url"
                              class="mt-[1px] text-xs font-bold md:hover:text-navHoverColor transition cursor-pointer leading-tight">
                            {{ breadcrumb.title }}
                        </Link>
                        <span v-else class="mt-[1px] text-xs font-bold cursor-default leading-tight">
                            {{ breadcrumb.title }}
                        </span>
                    </div>
                </li>
            </template>
            <template v-else>
                <li v-if="currentBreadcrumb" class="mb-3">
                    <div class="flex items-center gap-1 leading-tight">
                        <IconAngleLeft class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <Link :href="currentBreadcrumb.url"
                              class="mt-[1px] text-sm font-medium md:hover:text-navHoverColor transition leading-tight">
                            {{ currentBreadcrumb.title }}
                        </Link>
                    </div>
                </li>
            </template>
        </ol>
    </nav>
</template>

<script>
import {ref, computed, onMounted, onBeforeUnmount} from 'vue';
import {Link, usePage} from '@inertiajs/vue3';
import IconAngleLeft from '@js/components/Icons/IconAngleLeft.vue';
import {useThemeStore} from '@js/store/ThemeStore.js';

export default {
    name: "Breadcrumbs",
    components: {Link, IconAngleLeft},
    setup() {
        const themeStore = useThemeStore();
        const page = usePage();

        const breadcrumbs = ref(page.props.breadcrumbs || []);
        const showAllBreadcrumbs = ref(true);

        const currentBreadcrumb = computed(() => {
            return breadcrumbs.value.at(-1) ?? null;
        });

        const updateBreadcrumbsMode = () => {
            if (typeof window !== 'undefined') {
                showAllBreadcrumbs.value = !window.matchMedia('(max-width: 1024px)').matches;
            }
        };

        const insertSchemaMarkup = () => {
            if (typeof window === 'undefined') return;

            const scriptId = "schema-breadcrumbs-jsonld";
            let script = document.getElementById(scriptId);
            if (script) script.remove();

            script = document.createElement("script");
            script.id = scriptId;
            script.type = "application/ld+json";
            script.textContent = JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": breadcrumbs.value.map((breadcrumb, index) => ({
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": breadcrumb.title,
                    "item": breadcrumb.url
                }))
            });

            document.head.appendChild(script);
        };

        const removeSchemaMarkup = () => {
            const script = document.getElementById("schema-breadcrumbs-jsonld");
            if (script) script.remove();
        };

        onMounted(() => {
            updateBreadcrumbsMode();
            window.addEventListener("resize", updateBreadcrumbsMode);
            insertSchemaMarkup();
        });

        onBeforeUnmount(() => {
            window.removeEventListener("resize", updateBreadcrumbsMode);
            removeSchemaMarkup();
        });

        return {
            themeStore,
            breadcrumbs,
            showAllBreadcrumbs,
            currentBreadcrumb
        };
    }
};
</script>
